import React, { useState, useEffect, useRef, useLayoutEffect, } from 'react';
import { animated, useSpring, } from "react-spring";
import './App.css';
import './fonts/Audiowide-Regular.ttf';
import GameTitle from './GameTitle.js';
import Folder from './Folder.js';
import Drawcanvas from './Drawcanvas.js';
import Lobby from './Lobby.js';
import Welcome from './Welcome.js';
import Players from './Players.js';
import Timer from './Timer.js';
import Chat from './Chat.js';
import GameOverWin from './GameOverWin.js';
import GameOverLose from './GameOverLose.js';
import Tooltip from './Tooltip.js';
import HowToBtn from './HowToBtn.js';
import HowToPlayContent from './textContent/HowToPlayContent.js'
import HowToDrawContent from './textContent/HowToDrawContent.js'
import HowToVoteContent from './textContent/HowToVoteContent.js'
import { useDispatch, useSelector } from 'react-redux';
import { updateTurn, updateVotingState, updateReadyState, initGameState } from './redux/gameState';
import { setVote } from './redux/playerState';
import configState from './redux/configState';
import { Analytics } from "@vercel/analytics/react"

function App() {
  
  // TODO: Reorg components, potentially make a "content" component with cases for each main screen:
  // welcome, lobby, gamescreen, etc. these will be imported to this component

  // TODO: kick/ban, and related redux states. figure out how to reliably id players/connections for permanent room bans
  // maybe maintain the connection, but disallow the socket id from actually rendering anything

  // TODO: clean up unused constants

  // TODO: move all game components into the same single folder component for consistent open/close states

  // TODO: player component - reorder player list based on turn

  // TODO: add constants in separate file for app and server

  // -----

  // TODO: add transition animation for vote btn -> timer and maybe add more instructions in that section after voting

  // TODO: increase minimum player count

  // TODO: game instructions overview - more concise and clear

  // todo: tooltips not needed for every round, but a message notifying it is time to vote would be good

  // todo: rethink and reference rules from similar games

  // TODO: update how-to-play button

  // TODO: ***bug: last player tooltips seem to be "pre-dismissed" and do not show up ONLY ON a new game after finishing previous game. inconsistent reproduction

  // TODO: ***vote instructions not displaying for last player
  // ^^^^^^^ likely from last player being the last one drawing, and their drawing click action immediately dimissing tooltip

  // TODO: ***last player not included in new game after it finishes. Inconsistent steps to reproduce

  // TODO: ***bug: sometimes, upon returning to lobby from finished game, chat does not load in for 2nd player - havent been able to reproduce***

  // TODO: fix small screen folder background svg design

  // animations still need work, esp for exiting game or starting one. Seems cut off by border of parent element

  // animation speed needs tuning, esp start game and end game animations

  const [socket, setSocket] = useState(null);
  const [isDisabled, setDisabled] = useState(false);
  const gameState = useSelector((state) => state.gameState);
  const ps = useSelector((state) => state.playerState);
  const gameConfig = useSelector((state) => state.configState);
  const dispatch = useDispatch();
  //try and replace all above with below
  const [player, setPlayer] = useState(null);
  const [word, setWord] = useState("");
  const [started, setStarted] = useState(false);
  //TODO: use below later when adding optional config for user set round timer
  const [time, setTime] = useState(3);
  // const [canvas, setCanvas] = useState(null);
  const [lobby, setLobby] = useState(false);
  const [gameStartState, setGame] = useState(false);
  const [jiggle, setJiggle] = useState(false);
  const [glow, setGlow] = useState(false);
  const [jiggleCount, setJiggleCount] = useState(0);
  const [playerAnim, setPlayerAnim] = useState(false);
  const [canvasAnimFinished, setCanvasAnimFinished] = useState(false);
  const [shouldDisplayHowToDraw, setHowToDrawToolTip] = useState(true);
  const [countdownFinished, setCountdownFinished] = useState(false);

  const [tooltipToOpen, setToolTipOpen] = useState(false);
  //game over states, used for component display
  //fake artist lose
  const [gameOver1, setGame1] = useState("hidden");
  //fake artist win
  const [gameOver2, setGame2] = useState("hidden");
  const canvasC = useRef(null);

  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  useLayoutEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  // TODO: below needs cleanup

  useEffect(() => {
    if (player && player.faker === true) {
      setWord('');
    }
    else {
      if (gameState)
        setWord(gameState.word);
    }
  }, [gameState.word, player, gameState]);

  useEffect(() => {
    // todo: change gameState.round to check for # of rounds set in config (default to 2 or 3)
    if (gameState.turn === 0 && gameState.round === gameConfig.rounds + 1) {
      dispatch(updateVotingState(true));
      openToolTip(howtoVoteApi);
      votingModeAnim();
    }
    // no longer a case for this
    // if (gameState.turn === 0 && gameState.round >= gameConfig.rounds + 1) {
    //   dispatch(updateVotingState(true));
    //   votingModeAnim();
    // }
  }, [gameState.turn, gameState.round]);

  useEffect(() => {
    if (ps.voted) {
      endVoteAnim();
    }
  }, [ps.voted]);

  //might want to use a redux store instead of this player state, would require some readjustment to displaying secret word
  useEffect(() => {
    setPlayer(ps);
  }, [ps]);

  useEffect(() => {
    // TODO : error handling for socket connection issues
    if (socket !== null) {
      socket.on("connect_error", (err) => {
        // the reason of the error, for example "xhr poll error"
        console.log(err.message);

        // some additional description, for example the status code of the initial HTTP response
        console.log(err.description);

        // some additional context, for example the XMLHttpRequest object
        console.log(err.context);

        console.log(err);
      });
      return () => {
        socket.off('connect_error');
      }
    }
  }, [socket]);

  // refactor to only have 1 component/1 emitter with a result in response
  useEffect(() => {
    if (gameState.ready && socket !== null) {
      socket.once("fakerWon", () => {
        console.log("fake artist has won");
        setGame2("block");
        gameOverApi.start({
          y: 0,
          rotateZ: 0
        });
        maskApi.start({
          opacity: 0.20,
          zIndex: 2,
          display: "block",
        })
      });
      return () => {
        socket.off('fakerWon');
      }
    };
  }, [gameState.ready, socket]);

  useEffect(() => {
    if (gameState !== null && gameState.room !== null && socket !== null) {
      socket.emit("updateGameState", (gameState));
      return () => {
        socket.off('updateGameState');
      }
    };
  }, [gameState]);

  useEffect(() => {
    if (socket !== null) {
      console.log("updating game state");
      socket.once("updateGameState", (gameState) => {
        initGameState(gameState);
      });
      return () => {
        socket.off('updateGameState');
      }
    };
  }, [socket]);

  useEffect(() => {
    if (gameState.ready && socket !== null) {
      socket.once("fakerLost", () => {
        console.log("fake artist has lost");
        setGame1("block");
        gameOverApi.start({
          y: 0,
          rotateZ: 0
        });
        maskApi.start({
          opacity: 0.20,
          zIndex: 2,
          display: "block",
        })
      });
      return () => {
        socket.off('fakerLost');
      }
    };
  }, [gameState.ready, socket]);

  // useEffect(() => {
  //   if (socket !== null && gameState.ready) {
  //     socket.on("votingComplete", () => {
  //       openToolTip(fakerLivedApi);
  //     });
  //   }
  // });

  useEffect(() => {
    if (gameState.ready) {
      socket.once("newGame", () => {
        console.log("newgame received");
        gameOverApi.start({
          y: viewportHeight + 1000,
        })
        maskApi.start({
          opacity: 0,
          zIndex: 0,
          display: "none",
        })
        setTimeout(() => { springCallbackExit() }, 300);
      });
      return () => {
        socket.off('newGame');
      }
    };
  }, [gameState.ready, socket]);

  function lobbyLeave() {
    chatApi.start({
      y: -4200,
      rotateZ: -45
    });
  }

  useEffect(() => {
    if (lobby) {
      chatApi.start({
        y: 0,
        rotateZ: 0
      });
    }
  }, [lobby]);

  useEffect(() => {
    if (ps.myVote != "") {
      setGlow(false);
      timerPosApi.start({
        scale: 1.1,
        rotateZ: 10,
        zIndex: 3,
      });
    }
  }, [ps.myVote]);

  useEffect(() => {
    if (ps.voted) {
      timerPosApi.start({
        scale: 1,
        rotateZ: 0,
        zIndex: 2,
      });
    }
  }, [ps.voted]);

  // display tooltip if it is drawing time
  useEffect(() => {
    let turn = gameState.turn;
    if (shouldDisplayHowToDraw && gameState.players[turn] != null && gameState.ready && gameState.players[turn].id === player.id && !gameState.voting && gameState.round === 1 && canvasAnimFinished) {
      openToolTip(howtoDrawApi);
      setHowToDrawToolTip(!shouldDisplayHowToDraw)
    }
  }, [gameState, ps.id, canvasAnimFinished]);

  function castVote(v) {
    setGlow(false);
    dispatch(setVote(v));
  }

  // refactor
  function countDownFinish(c) {
    setTime(configState.maxTime);
    if (c === 0) {
      // emit current canvas data
      setDisabled(true);
      setCountdownFinished(true);
      dispatch(updateTurn(gameState.turn + 1));
      canvasApi.start({
        zIndex: 0,
      });
      maskApi.start({
        opacity: 0.20,
        zIndex: 1,
        display: "block",
      });
    }
  }

  function turnStart(started) {
    setCountdownFinished(false);
    setStarted(started);
  }

  function newGame() {
    console.log("init new game");
    setLobby(true);
    setGame(false);
    dispatch(updateReadyState(false));
    setGame1("hidden");
    setGame2("hidden");
    let game = {
      "players": gameState.players,
      "room": gameState.room,
      "turn": 0,
      "drawing": "",
      "ready": false,
      "word": "",
      "voting": false,
      // hate this below
      "voteComplete": false,
      "messages": gameState.messages,
      "faker": {},
      "round": 1,
    }
    dispatch(initGameState(game));
    setHowToDrawToolTip(false);
  }

  function socketConnect(s) {
    setSocket(s);
  }

  function openLobby(e) {
    setLobby(e);
  }

  function openGame(e) {
    setLobby(false)
    setGame(e);
  }

  function openToolTip(type) {
    // need to adjust if case for all tooltip types
    if (!tooltipToOpen) {
      maskApi.start({
        opacity: 0.20,
        zIndex: 2,
        display: "block",
        config: {
          duration: 0,
        },
      });
      if (!(type === howtoDrawApi && !shouldDisplayHowToDraw)) {
        type.start({
          display: "block",
          immediate: true,
          opacity: 1,
          config: {
            duration: 0,
          }
        });
        type.start({
          x: 0,
          rotateZ: 0,
          zIndex: 210,
          delay: 200,
          config: {
            duration: 600,
          },
        });
      }
      setTimeout(() => { return setToolTipOpen(true) }, 300);
    }
  }

  // TODO: must be a way to reuse spring across 3 components

  function dismissToolTip(type) {
    // need to adjust if case for all tooltip types
    if (tooltipToOpen) {
      if (!gameState.voting) {
        maskApi.start({
          opacity: 0,
          zIndex: 0,
          display: "none",
          // hopefully delay helps to resolve resizing bug
          delay: 750,
        });
      }
      type.start({
        x: viewportWidth * 1.5,
        rotateZ: -45,
        // zIndex: 3,
        onRest: () => {
          type.start({
            display: "none",
            immediate: true,
            config: {
              duration: 0,
            }
          });;
          return setToolTipOpen(false)
        },
      });
      setTimeout(() => { return setToolTipOpen(false) }, 300);
    }
  }

  function dismissAllToolTips() {
    if (!tooltipToOpen) {
      return;
    }
    dismissToolTip(howtoDrawApi);
    dismissToolTip(howtoVoteApi);
    dismissToolTip(howToApi);
    dismissToolTip(fakerLivedApi);
    setToolTipOpen(false);
  }

  function votingModeAnim() {
    canvasApi.start({
      scale: 0.95,
      zIndex: 1,
      boxShadow: 'none',
    });
    setJiggle(true);
    setGlow(true);
    playersApi.start({
      scale: 1.05,
      boxShadow: 'none',
      config: {
        duration: 100,
        delay: 100
      },
      reverse: true,
      zIndex: 3,
      onRest: () => { setPlayerAnim(true) },
    });
    timerPosApi.start({
      zIndex: 3
    });
    maskApi.start({
      opacity: 0.20,
      zIndex: 2,
      display: "block",
    });
  }

  function endVoteAnim() {
    setPlayerAnim(false);
    canvasApi.start({
      scale: 1,
      boxShadow: 'none',
      zIndex: 1
    });
    setJiggle(false);
    setGlow(false);
    playersApi.start({
      scale: 1,
      config: { duration: 100 },
      zIndex: 1
    });
    timerPosApi.start({
      zIndex: 1
    });
  }
  // Spring Animations ----------------------------------------------------------------

  function springCallback() {
    playersApi.start({
      y: 0,
      rotateZ: 0
    });

    timerPosApi.start({
      x: 0,
      rotateZ: 0
    });

    canvasApi.start({
      y: 0,
      rotateZ: 0
    });

    chatApi.start({
      y: 0,
      rotateZ: 0
    });
  }

  function springCallbackExit() {
    playersApi.start({
      y: viewportHeight + 1000,
      rotateZ: -45,
      config: {
        duration: 500,
        delay: 300,
      }
    });

    timerPosApi.start({
      x: viewportWidth * 1.5,
      rotateZ: 0,
      config: {
        duration: 500,
        delay: 300,
      }
    });

    canvasApi.start({
      y: viewportHeight + 1000,
      rotateZ: 90,
      config: {
        duration: 500,
        delay: 300,
      }
    });

    chatApi.start({
      y: viewportHeight + 1200,
      rotateZ: -45,
      config: {
        duration: 500,
        delay: 300,
      }
    });
    setTimeout(() => { newGame() }, 300);
  }

  const [playersPos, playersApi] = useSpring(() => ({
    from: {
      y: viewportHeight + 1000,
      rotateZ: -45,
      scale: 1,
      boxShadow: 'none',
    },
    config: { duration: 300 },
  }))

  const [canvasPos, canvasApi] = useSpring(() => ({
    from: {
      y: viewportHeight + 1500,
      rotateZ: 90,
      scale: 1,
      boxShadow: '0 40px 80px 0 black',
    },
    config: {
      duration: 500,
    },
    // delay: 500,
    onRest: () => { setCanvasAnimFinished(true) },
  }))

  const [chatPos, chatApi] = useSpring(() => ({
    from: {
      y: viewportHeight + 1200,
      rotateZ: -45
    },
    config: { duration: 500 },
    // delay: 500,
  }))

  const jiggleSpring = useSpring({
    rotation: jiggle ? (jiggleCount % 2 === 0 ? 1 : -1) : 0, // Alternate between 1 and -1 degrees
    from: { rotation: 0 }, // Start from 0 rotation
    config: { duration: 100 }, // Adjust duration as needed
    onRest: () => {
      if (jiggle && jiggleCount < 3 * 2) {
        // If still jiggling and not reached max count, increase count and trigger jiggle
        setJiggleCount(prevCount => prevCount + 1);
      } else {
        // If reached max count or stopped jiggling, reset count and stop jiggling
        setJiggleCount(0);
        setJiggle(false);
      }
    }
  });

  const [timerPos, timerPosApi] = useSpring(() => ({
    from: {
      x: viewportWidth * 1.5,
      scale: 1
    },
    config: { duration: 300 },
  }))

  const [maskSpring, maskApi] = useSpring(() => ({
    from: {
      opacity: 0,
      zIndex: 0,
      display: "none",
    },
    config: { duration: 300 },
  }))

  const [gameOverPos, gameOverApi] = useSpring(() => ({
    from: {
      y: viewportHeight + 1000,
      zIndex: 400,
    },
    config: {
      duration: 500,
      delay: 500,
    },
  }))

  // TODO: should be a way to use useSprings here, but doing this quick and dirty first

  const [howtoDrawPos, howtoDrawApi] = useSpring(() => ({
    from: {
      display: "hidden",
      x: viewportWidth * 1.5,
      rotateZ: 0,
    },
    config: {
      duration: 800,
      delay: 2000,
    },
    delay: 2000,
  }))

  const [howtoVotePos, howtoVoteApi] = useSpring(() => ({
    from: {
      display: "none",
      x: viewportWidth * 1.5,
      rotateZ: 0,
    },
    config: {
      duration: 800,
    },
    delay: 2000,
  }))

  const [howToPos, howToApi] = useSpring(() => ({
    from: {
      display: "none",
      opacity: 0,
      x: viewportWidth * 1.5,
      rotateZ: -15,
    },
  }))

  const [fakerLivedPos, fakerLivedApi] = useSpring(() => ({
    from: {
      display: "none",
      x: viewportWidth * 1.5,
      rotateZ: 0,
    },
    config: {
      duration: 800,
    },
    delay: 2000,
  }))

  // End Spring Animations ----------------------------------------------------------------

  if (gameState.players.length > 0 && gameState.ready && socket !== null && gameStartState) {
    return (
      <div className="App flex flex-col w-full h-screen active-game overflow-y-visible md:overflow-y-hidden " onClick={() => dismissAllToolTips()}>
        <div className='m-auto w-full h-screen relative flex flex-col overflow-x-hidden'>
          <GameTitle className="z-100 absolute" />
          <div className='h-full content-center absolute sm:relative sm:mt-0 game-content'>
            <animated.div className="absolute w-full top-1/3 z-100 flex" style={{ ...gameOverPos }}>
              <GameOverWin display={gameOver1} socket={socket} secret={gameState.word} faker={gameState.faker} />
              <GameOverLose display={gameOver2} socket={socket} secret={gameState.word} faker={gameState.faker} />
            </animated.div>

            {/* use this as template for the rest of tooltips, or better yet move to component */}
            <animated.div className="absolute w-full top-1/4 z-40 overflow-hidden" style={{ ...howtoDrawPos }} type={"drawInstructions"} >
              <Tooltip header={"On your turn"} dismiss={(t) => dismissToolTip(howtoDrawApi)}>
                <HowToDrawContent gameConfig={gameConfig} gameState={gameState} player={player} />
              </Tooltip>
            </animated.div>

            {/* need faker specific instructions */}
            <animated.div className="absolute w-full top-1/4 z-40 overflow-hidden " style={{ ...howtoVotePos }} type={"voteInstructions"} >
              <Tooltip header={"Vote for the impostor artist!"} dismiss={(t) => dismissToolTip(howtoVoteApi)}>
                <HowToVoteContent state={gameState} player={player} />
              </Tooltip>
            </animated.div>

            {/* might remove this tooltip if I change game rules - i.e. only voting at the end of all rounds */}
            <animated.div className="absolute w-full top-1/4 z-40 overflow-hidden " style={{ ...fakerLivedPos }} type={"voteInstructions"} >
              <Tooltip header={"The faker has not yet been found"} dismiss={(t) => dismissToolTip(fakerLivedApi)}>
                <p>The faker has not yet been voted out.</p>
                <p>Another round has started, continue collaborating on the drawing!</p>
              </Tooltip>
            </animated.div>
            {/* addspace? */}
            <div className='left-margin w-1/5'> </div>
            <Folder open={(s) => springCallback(s)} begin={true}>
              {/* maybe put all of this into its own component? */}
              <div className="App-body game-body grid md:grid-flow-row grid-cols-12 w-full max-w-screen-xl m-auto px-8 ">
                <animated.div id={"opMask"} className={"opacity-20 bg-gray-500 w-screen h-screen fixed top-0 left-0 overflow-y-hidden"} style={{ ...maskSpring }}></animated.div>
                <div className="gamepanel-left md:col-span-2 s:col-start-3 md:col-start-2 col-span-12 h-full flex md:flex-col md:gap-0 md:mr-4">
                  <animated.div className={"player-list md:w-full h-full w-3/4 mr-2 md:mr-0 md:relative static " + (glow ? "glow" : "")} style={{ ...playersPos, transform: jiggleSpring.rotation.to(rotation => `rotate(${rotation}deg)`) }}>
                    <Players
                      gameState={gameState}
                      currentTurn={gameState.turn}
                      players={gameState.players}
                      player={ps}
                      votePlayer={(vote) => castVote(vote)}
                      socket={socket}
                      playerAnim={playerAnim}
                      lobby={lobby}
                    />
                  </animated.div>
                  <animated.div className={"timer w-24 h-24 md:w-32 md:h-32 xl:w-40 xl:h-40 justify-items-center m-auto z-10 md:mt-4 md:m-auto ml-2 " + ((gameState.voting && ps.myVote !== "") ? "" : "")} style={{ ...timerPos }}>
                    <div className="align-center h-full content-center">
                      <Timer count={(c) => countDownFinish(c)} started={started} maxTime={time} socket={socket} />
                    </div>
                  </animated.div>
                </div>
                <animated.div className="canvas-body md:col-span-6 col-span-12 bg-gray-100 my-2 md:mb-auto rounded-sm" style={{ ...canvasPos }}>
                  <Drawcanvas ref={canvasC}
                    enteredName={gameState.name}
                    roomCode={gameState.room}
                    io={socket}
                    disabled={isDisabled}
                    currentTurn={gameState.turn}
                    word={word}
                    startTurn={(started) => turnStart(started)}
                    maxTime={time}
                    socket={socket}
                    tooltipToOpen={tooltipToOpen}
                    countdownFinished={countdownFinished}
                  />
                </animated.div>
                <animated.div id='chatGame' className="pb-5 md:py-0 md:col-span-3 col-span-12 mx-1 md:mx-0 flex-1 z-10 md:w-auto md:ml-4" style={{ ...chatPos }}>
                  <Chat socket={socket} />
                </animated.div>
              </div>
              {/* <div className='h-full'>adspace?</div> */}
            </Folder>
            {/* addspace? */}
            <div className='right-margin w-1/5'> </div>
          </div>
        </div>
        <Analytics />
      </div>
    );
  }
  else if (lobby) {
    return (
      <div className="App flex flex-col h-screen overflow-hidden" onClick={() => dismissAllToolTips()}>
        <div className='m-auto w-full h-screen overflow-hidden relative flex flex-col'>
          <GameTitle />
          <animated.div className="absolute w-full top-40 md:top-1/4 z-40" style={{ ...howToPos }} type={"howTo"} >
            <Tooltip header={"How to play"} dismiss={(t) => dismissToolTip(howToApi)}>
              <HowToPlayContent />
            </Tooltip>
          </animated.div>
          <HowToBtn open={() => openToolTip(howToApi)} />
          <Folder open={(s) => springCallback(s)} begin={false}>
            <div className="align-content-center mx-auto flex place-content-center h-screen absolute">
              <Lobby socket={socket} gameState={gameState} gameStart={(e) => openGame(e)} lobby={lobby} lobbyLeave={(e) => lobbyLeave()} >
                <animated.div id='chatLobby' className="py-5 md:py-0 md:col-span-4 col-span-12 mx-1 md:mx-0 flex-1place-content-center " style={{ ...chatPos }}>
                  <Chat socket={socket} />
                </animated.div>
              </Lobby>
            </div>
          </Folder>
        </div>
        <Analytics />
      </div>
    );
  }
  else {
    return (
      <div className="App flex flex-col h-screen overflow-hidden" onClick={() => dismissAllToolTips()}>
        <div className='m-auto w-full h-screen overflow-hidden relative flex flex-col'>
          <GameTitle />
          <animated.div className="absolute w-full top-40 md:top-1/4 z-40" style={{ ...howToPos }} type={"howTo"} >
            <Tooltip header={"How to play"} dismiss={(t) => dismissToolTip(howToApi)}>
              <HowToPlayContent />
            </Tooltip>
          </animated.div>
          <HowToBtn open={() => openToolTip(howToApi)} />
          <Folder open={(s) => springCallback(s)} begin={false}>
            <div className="mx-auto pt-20 md:px-20 lg:px-50 max-h-16 md:max-h-32 lg:max-w-7xl md:pt-10 md:grid md:grid-flow-row md:grid-cols-12">
              <Welcome
                lobbyStart={(e) => openLobby(e)}
                gameStatus={''}
                PID={ps.id}
                socket={(openedSocket) => socketConnect(openedSocket)}
                className="" />
            </div>
          </Folder>
        </div>
        <Analytics />
      </div>
    );
  }
}
App.whyDidYouRender = { logOnDifferentValues: true };
export default App;